
// Aliases and default props for vuetify components, see https://vuetifyjs.com/en/features/global-configuration/#component-defaults
// Try not to use this file directly in your app, but include vuetifyDefaultConfig.ts into your vuetify.ts instead!

import { VBtn } from 'vuetify/components/VBtn'

const aliasesAndDefaults = {

    aliases: { 
        CrvBtnPrimary: VBtn as unknown,
        CrvBtnSecondary: VBtn as unknown,
        CrvBtnSubmit: VBtn as unknown,
    },
    defaults: {

        global: {
            ripple: false,
            // class: 'crv-vuetify-styling', // Global-set classes does not work.
          },

        CrvBtnPrimary: { // example alias for VBtn
            class: ['v-btn--primary', 'text-none'], // 'v-btn--primary': Vuetify2 way of setting primary button style
            color: "primary"
        },

        CrvBtnSecondary: {
            class: ['mx-4'], // vuetify-margin x 4
            color: "secondary"
        },

        CrvBtnSubmit: { 
            color: "submit",
            type: "submit",
            variant: "flat"
        },


        //class: 'crv-vuetify-styling': Wrapper-class for most used vuetify components in order to force crv-vuetify-styling
        VAlert: { class: 'crv-vuetify-styling' },
        VBtn: { class: 'crv-vuetify-styling'},
        VCard: { class: 'crv-vuetify-styling', }, // setting color, or border somehow don't work.
        VCheckbox: { class: "crv-vuetify-styling", color: "base-blue-80",  },
        VChip: { class: 'crv-vuetify-styling' },
        VCol: { class: 'crv-vuetify-styling' },
        VContainer: { class: 'crv-vuetify-styling' },
        VDataTable: { class: 'crv-vuetify-styling', 'color': 'primary'},
        VDatePicker: { class: 'crv-vuetify-styling' },
        VDialog: { class: 'crv-vuetify-styling' },
        VDivider: { class: 'crv-vuetify-styling' },
        VIcon: { class: 'crv-vuetify-styling' },
        VListItem: { class: 'crv-vuetify-styling' },
        VMenu: { class: 'crv-vuetify-styling' },
        VOverlay: { class: 'crv-vuetify-styling' },
        VProgressCircular: { class: 'crv-vuetify-styling' },
        VRow: { class: 'crv-vuetify-styling' },
        VSelect: { class: 'crv-vuetify-styling' },
        VSlider: { class: 'crv-vuetify-styling' },
        VSpacer: { class: 'crv-vuetify-styling' },
        VSwitch: { class: 'crv-vuetify-styling' },
        VTab: { class: 'crv-vuetify-styling' },
        VTable: { class: 'crv-vuetify-styling', color: 'primary'},
        VTabItem: { class: 'crv-vuetify-styling' },
        VTextField: { class: 'crv-vuetify-styling' },
        VTextarea: { class: 'crv-vuetify-styling' },
        VToolbar: { class: 'crv-vuetify-styling' },
        VTooltip: { class: 'crv-vuetify-styling' },
    }
}

export default aliasesAndDefaults